/**
 * @remarks \@since 2.4.0
 */
export var DEFAULT_OVERLAY_TIMEOUT = 150;
/**
 * @remarks \@since 2.4.0
 */
export var DEFAULT_OVERLAY_CLASSNAMES = {
  appearActive: "rmd-overlay--active",
  appearDone: "rmd-overlay--active",
  enterActive: "rmd-overlay--active",
  enterDone: "rmd-overlay--active"
};